export default __webpack_public_path__ + "e395fe694300c8a0f6af0ba6558c69d7.png";